import { useUpgradeSusdcDialog } from './logic/useUpgradeSusdcDialog'
import { UpgradeSusdcView } from './views/UpgradeSusdcView'
import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'
import { SuccessView } from '@/features/dialogs/common/views/SuccessView'
import { withSuspense } from '@/ui/utils/withSuspense'

interface UpgradeSusdcDialogContentContainerProps {
  closeDialog: () => void
}

function UpgradeSusdcDialogContentContainer({ closeDialog }: UpgradeSusdcDialogContentContainerProps) {
  const { susdc, susdcBalance, pageStatus, upgradeAmount, actionsViewState, form, formFields, txOverview } =
    useUpgradeSusdcDialog()

  if (pageStatus.state === 'success') {
    return (
      <SuccessView
        tokenWithValue={{ token: susdc, value: upgradeAmount }}
        proceedText="Back to Savings"
        objectiveType="upgradeSusdc"
        onProceed={closeDialog}
        className="p-6"
      />
    )
  }

  return (
    <UpgradeSusdcView
      susdc={susdc}
      susdcBalance={susdcBalance}
      actionsViewState={actionsViewState}
      form={form}
      formFields={formFields}
      txOverview={txOverview}
    />
  )
}

const UpgradeSusdcDialogContentContainerWithSuspense = withSuspense(
  UpgradeSusdcDialogContentContainer,
  DialogContentSkeleton,
)
export { UpgradeSusdcDialogContentContainerWithSuspense as UpgradeSusdcDialogContentContainer }
